var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "avatar-chat-container" }, [
    _c("div", { staticClass: "chat-header sticky" }, [
      _c("div", { staticClass: "chat-header-content" }, [
        _c("div", { staticClass: "chat-title" }, [
          _c("div", {
            staticClass: "header-avatar",
            style: _vm.avatarImageStyle
          }),
          _vm._v(" "),
          _c("h1", [_vm._v(_vm._s(_vm.username) + "'s AI Twin")])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "chat-input-container" }, [
      _c("div", { staticClass: "chat-input-wrapper" }, [
        _c("textarea", {
          staticClass: "message-input",
          attrs: {
            placeholder: "Ask me anything...",
            rows: "4",
            spellcheck: "false",
            disabled: ""
          }
        }),
        _vm._v(" "),
        _c("button", { staticClass: "send-button disabled" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none"
              }
            },
            [
              _c("path", {
                attrs: {
                  d: "M12 19V5m0 0l-7 7m7-7l7 7",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              })
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "welcome-message-container" }, [
      _c("h2", { staticClass: "welcome-text" }, [
        _vm._v("Hi "),
        _c("span", { staticClass: "emoji" }, [_vm._v("👋")]),
        _vm._v(" How can I help?")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }